import * as React from "react";
import { Switch, useLocation } from "react-router-dom";

import LocationTransitionWrapper, { Props } from "./LocationTransitionWrapper";

export default function RouteTransitionWrapper({
  children,
  ...otherProps
}: Props) {
  const location = useLocation();

  return (
    <LocationTransitionWrapper {...otherProps}>
      <Switch location={location}>{children}</Switch>
    </LocationTransitionWrapper>
  );
}
